function trim(str) {
    const value = str === null ? '' : str;
    return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

export default trim;
